import { default as ReactSwitch } from 'react-switch';

export const Switch = ({
    isChecked = false,
    onChange = () => {},
    disabled = false,
    ...props
}) => {
    return (
        <ReactSwitch
            onChange={onChange}
            checked={isChecked}
            disabled={disabled}
            onColor="#7f56d9"
            offColor="#e5e7eb"
            uncheckedIcon={false}
            checkedIcon={false}
            height={24}
            width={44}
            activeBoxShadow="0px 0px 1px 2px #7f56d9"
            {...props}
        />
    );
};
